import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import autoBind from 'auto-bind'
import moment from 'moment'

/** Import component section */
import '../../resources/styles/autosuggest.css'
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import Toaster from '../common/Toaster'
import FormHeaderCard from './Components/FormHeaderCard'
import SuppliersCard from './Components/SuppliersCard'

/** Translations imports section */
import { Translate, getTranslate } from 'react-localize-redux'

/** Material-UI imports section */
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'

/** Import section actions */
import { searchBySuppliersByQury } from '../../store/suppliers/SupplierActions'
import { requestContractData } from '../../store/supplierconstracts/SupplierConstractAction'
import { DOCUMENT_CONTRACTOR } from '../../store/helpers/ResourcesHelper'

/**
 * Container to Create contract
 */
class Create extends Component {
	/**
	 * Creates an instance of View.
	 * @param {*} props
	 * @memberof View
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			showToaster: false,
			toasterMessage: null,
			toasterVariant: '',
			contract: {
				attachments: [],
				activationDate: '',
				expirationDate: '',
				supplierSelected: null,
				name: '',
				notes: '',
				documentType: DOCUMENT_CONTRACTOR,
				requestedBy: '',
				specialConditions: '',
				specialCondition: ['', '', '', ''],
				typeDeal: 0,
				descriptionOfServices: '',
				descriptionOfService: ['', '', '', ''],
			},
		}
	}

	/**
	 * Update the properties in state
	 *
	 * @param {*} user
	 * @param {*} element
	 * @memberof View
	 */
	updateProperty(property, element) {
		const { id, value } = element
		let contractpdate = { ...this.state.contract }
		contractpdate['specialConditions'] = ''
		contractpdate['descriptionOfServices'] = ''
		if (property === 'specialCondition')
			switch (element) {
				case 'Garantias':
					contractpdate['specialCondition'][0].length > 0
						? (contractpdate['specialCondition'][0] = '')
						: (contractpdate['specialCondition'][0] = element)
					contractpdate['specialCondition'].forEach(
						(element) =>
							(contractpdate['specialConditions'] = contractpdate['specialConditions'].concat(
								contractpdate['specialConditions'].length > 0 ? ',' : '',
								element
							))
					)
					break
				case 'Seguros':
					contractpdate['specialCondition'][1].length > 0
						? (contractpdate['specialCondition'][1] = '')
						: (contractpdate['specialCondition'][1] = element)
					contractpdate['specialCondition'].forEach(
						(element) =>
							(contractpdate['specialConditions'] = contractpdate['specialConditions'].concat(
								contractpdate['specialConditions'].length > 0 ? ',' : '',
								element
							))
					)
					break
				case 'Fianzas':
					contractpdate['specialCondition'][2].length > 0
						? (contractpdate['specialCondition'][2] = '')
						: (contractpdate['specialCondition'][2] = element)
					contractpdate['specialCondition'].forEach(
						(element) =>
							(contractpdate['specialConditions'] = contractpdate['specialConditions'].concat(
								contractpdate['specialConditions'].length > 0 ? ',' : '',
								element
							))
					)
					break
				case 'Penalizaciones':
					contractpdate['specialCondition'][3].length > 0
						? (contractpdate['specialCondition'][3] = '')
						: (contractpdate['specialCondition'][3] = element)
					contractpdate['specialCondition'].forEach(
						(element) =>
							(contractpdate['specialConditions'] = contractpdate['specialConditions'].concat(
								contractpdate['specialConditions'].length > 0 ? ',' : '',
								element
							))
					)
					break
				default:
					break
			}
		else if (property === 'descriptionOfServices')
			switch (id) {
				case 'filled-margin-dense-0':
					contractpdate['descriptionOfService'][0] = value
					contractpdate['descriptionOfService'].forEach(
						(element) =>
							(contractpdate['descriptionOfServices'] = contractpdate['descriptionOfServices'].concat(
								contractpdate['descriptionOfServices'].length > 0 ? ',' : '',
								element
							))
					)
					break
				case 'filled-margin-dense-1':
					contractpdate['descriptionOfService'][1] = value
					contractpdate['descriptionOfService'].forEach(
						(element) =>
							(contractpdate['descriptionOfServices'] = contractpdate['descriptionOfServices'].concat(
								contractpdate['descriptionOfServices'].length > 0 ? ',' : '',
								element
							))
					)
					break
				case 'filled-margin-dense-2':
					contractpdate['descriptionOfService'][2]  = value
					contractpdate['descriptionOfService'].forEach(
						(element) =>
							(contractpdate['descriptionOfServices'] = contractpdate['descriptionOfServices'].concat(
								contractpdate['descriptionOfServices'].length > 0 ? ',' : '',
								element
							))
					)
					break
				case 'filled-margin-dense-3':
					contractpdate['descriptionOfService'][3]  = value
					contractpdate['descriptionOfService'].forEach(
						(element) =>
							(contractpdate['descriptionOfServices'] = contractpdate['descriptionOfServices'].concat(
								contractpdate['descriptionOfServices'].length > 0 ? ',' : '',
								element
							))
					)
					break
				default:
					break
			}
		else contractpdate[property] = element
		this.setState({
			contract: contractpdate,
		})
	}

	/**
	 * On seletecd supplier
	 */
	onSupplierSelected(supplier) {
		let contractpdate = { ...this.state.contract }
		contractpdate.supplierSelected = supplier
		this.setState({
			contract: contractpdate,
		})
	}

	/**
	 * Remove files
	 */
	removeFiles(fileName) {
		let attachments = this.state.contract.attachments.filter((file) => {
			return file.name !== fileName
		})
		this.setState({
			contract: {
				...this.state.contract,
				attachments,
			},
		})
		return Promise.resolve('Ok')
	}

	/**
	 * Add file
	 * @param {*} attachments
	 */
	uploadFiles(files) {
		let filesList = this.state.contract.attachments
		if (files.length > 0) {
			for (var index = 0; index < files.length; index++) {
				filesList.push(files[index])
			}
		}
		this.setState({
			contract: {
				...this.state.contract,
				attachments: filesList,
			},
		})
		return Promise.resolve('Ok')
	}

	/**
	 * Action to can be  information
	 */
	canBeSaved() {
		if (this.props.isSaving) return false
		else {
			let contract = this.state.contract
			if (contract.activationDate.length === 0) return false
			if (contract.expirationDate.length === 0) return false
			if (moment(contract.expirationDate).isBefore(contract.activationDate)) return false
			if (contract.attachments.length <= 0) return false
			if (contract.supplierSelected === null) return false
		}
		return true
	}

	/**
	 * Function to create
	 * @param {*} worker
	 */
	onCreateContractData() {
		this.props
			.requestContractData(this.state.contract)
			.then(() => {
				this.setState({
					showAddWorker: false,
					showToView: true,
					showToaster: true,
					toasterMessage: <Translate id='common.addCorrectly' />,
					toasterVariant: 'success',
				})
				this.props.history.push(`/contracts`)
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToAdd' />,
					toasterVariant: 'error',
				})
			})
	}

	/**
	 * Render show
	 */
	render() {
		return (
			<Grid container spacing={24}>
				<Grid item xs={7}>
					<FormHeaderCard
						updateProperty={this.updateProperty}
						contract={this.state.contract}
						onCreateContractData={this.onCreateContractData}
						canBeSaved={this.canBeSaved()}
						uploadFiles={this.uploadFiles}
						removeFiles={this.removeFiles}
						dropzoneText={this.props.translate('dropzone.dropzoneBase')}
                        request = {true}
						{...this.props}
					/>
				</Grid>
				<Grid item xs={5}>
					<SuppliersCard
						contract={this.state.contract}
						updateProperty={this.updateProperty}
						onSupplierSelected={this.onSupplierSelected}
						{...this.props}
					/>
				</Grid>

				<Toaster
					message={this.state.toasterMessage}
					open={this.state.showToaster}
					variant={this.state.toasterVariant}
					onClose={() => {
						this.setState({ showToaster: false })
					}}
				/>
			</Grid>
		)
	}
}

/**
 * Map state to props mapStateToProps
 * @param {*} state
 */
function mapStateToProps(state) {
	let selectedCompanyIdentifier = state.profile.get('selectedCompany').get('get_company_identifier')

	return {
		selectedCompanyIdentifier: selectedCompanyIdentifier ? selectedCompanyIdentifier : null,
		isLoadingUser: state.oidc.isLoadingUser,
		isLoadingSuppliers: state.suppliers.get('isLoadingSuppliers'),
		isSaving: state.contracts.get('isSavingContract'),
		translate: getTranslate(state.localize),
	}
}

/**
 * mapDispatchToProps
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		searchBySuppliersByQury: (query) => {
			dispatch(searchBySuppliersByQury(query))
		},
		requestContractData: (contract) => {
			return dispatch(requestContractData(contract))
		},
	}
}

const viewStyles = (theme) => ({
	userAvatar: {
		backgroundColor: theme.palette.secondary.main,
	},
	textField: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
		width: 240,
	},
	toolBar: {
		backgroundColor: 'red',
	},
	button: {
		margin: theme.spacing.unit,
	},
	errorMessage: {
		color: theme.palette.common.white,
	},
	formatCheck: {
		display: 'flex',
		marginLeft: theme.spacing.unit,
		width: 460,
	},
	documentTypeSelect: {
		marginRight: '5px',
	},
})

export default withauthenticatedLayout(
	withRouter(withStyles(viewStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Create)))
)
